module.exports = __webpack_public_path__ + "static/media/31.fec4cdd1.jpg";